var viewer_default = {
  "gallery_container": "kwJM5",
  "imageTitleContainer": "qnZ81",
  "clickableItem": "D1-h8",
  "prerender": "vyfao",
  "expandButton": "GszHG",
  "itemContainer": "Ibzwp",
  "expandIcon": "PqKns",
  "itemOverlay": "fc3vh",
  "imageTitle": "JlLVy",
  "pointer": "RoBW5",
  "fadeIn": "AttwG",
  "changing_background": "rDScZ"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
